import React from 'react';
import { Chip, PersonAvatar } from '../../../../components/immobilien/ui';
import { initialen } from '../../../../lib/immobilien/format';
import { avatarTon, type DlZeile } from '../../../../lib/dienstleister/liste';
import { DL_STATUS, statusText } from '../../../../lib/dienstleister/status';
import { bewertungText, GOLD, objekteText, rechnungAnzeige } from './DienstleisterKachel';

const SPALTEN = 'minmax(170px,1.4fr) minmax(150px,1.2fr) 110px 84px 84px 104px 140px';

/** Listenansicht (README §6): Name · Kategorien · Telefon · Aufträge · Bewertung · Rechnungen · Status. */
export function DienstleisterTabelle({ zeilen, onOeffnen }: { zeilen: readonly DlZeile[]; onOeffnen: (id: string) => void }) {
  const tastatur = (id: string) => (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onOeffnen(id); }
  };
  return (
    <section className="immo-glas overflow-x-auto" style={{ borderRadius: 26, padding: 6 }} aria-label="Dienstleister als Liste">
      <div role="table" className="flex flex-col" style={{ minWidth: 860 }}>
        <div role="row" className="grid"
          style={{ gridTemplateColumns: SPALTEN, gap: 10, padding: '12px 14px', fontSize: 11, fontWeight: 800, letterSpacing: '0.05em', textTransform: 'uppercase', color: 'var(--ink3)' }}>
          <span role="columnheader">Name</span><span role="columnheader">Kategorien</span><span role="columnheader">Telefon</span>
          <span role="columnheader" style={{ textAlign: 'right' }}>Aufträge</span><span role="columnheader" style={{ textAlign: 'right' }}>Bewertung</span>
          <span role="columnheader" style={{ textAlign: 'right' }}>Rechnungen</span><span role="columnheader" style={{ textAlign: 'right' }}>Status</span>
        </div>
        {zeilen.map(z => {
          const st = DL_STATUS[z.status];
          const re = rechnungAnzeige(z);
          return (
            <div key={z.id} role="row" tabIndex={0} aria-label={`${z.name} öffnen`} onClick={() => onOeffnen(z.id)} onKeyDown={tastatur(z.id)}
              className="immo-hover-flaeche grid items-center cursor-pointer"
              style={{ gridTemplateColumns: SPALTEN, gap: 10, padding: '10px 14px', borderRadius: 16, fontSize: 13 }}>
              <span role="cell" className="flex items-center min-w-0" style={{ gap: 10 }}>
                <PersonAvatar text={initialen(z.name)} ton={avatarTon(z)} groesse={32} />
                <span className="flex flex-col min-w-0">
                  <b className="truncate" style={{ fontWeight: 800 }}>{z.name}</b>
                  <span className="truncate" style={{ fontSize: 11, color: 'var(--ink3)' }}>{z.email || '–'}</span>
                </span>
              </span>
              <span role="cell" className="flex flex-col min-w-0">
                <span className="truncate" style={{ fontWeight: 600 }}>{z.kategorien.join(', ') || '–'}</span>
                <span className="truncate" style={{ fontSize: 11, color: 'var(--ink3)' }}>{objekteText(z)}</span>
              </span>
              <span role="cell" className="immo-zahl truncate" style={{ color: 'var(--ink2)' }}>{z.telefon || '–'}</span>
              <span role="cell" className="immo-zahl" style={{ textAlign: 'right' }}>{z.offeneAuftraege}</span>
              <b role="cell" className="immo-zahl" style={{ textAlign: 'right', fontWeight: 800, color: z.bewertung === null ? 'var(--ink3)' : GOLD }}>{bewertungText(z.bewertung)}</b>
              <b role="cell" className="immo-zahl truncate" style={{ textAlign: 'right', fontWeight: 800, color: re.farbe }}>{re.text}</b>
              <span role="cell" className="flex justify-end min-w-0"><Chip ton={st.ton} groesse="xs">{statusText(z.status, z.vertragEndet)}</Chip></span>
            </div>
          );
        })}
      </div>
    </section>
  );
}
